/**
 * This component serves as the main dashboard for authenticated users.
 * It handles fetching, displaying, creating, editing, and deleting notes from Firestore.
 * It also manages modals for sharing notes and posting to the blog.
 */


import PushPinIcon from "@mui/icons-material/PushPin";
import { doc, setDoc, collection, getDocs, query, where, deleteDoc } from "firebase/firestore";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import "draft-js/dist/Draft.css";
import HTMLParser from "html-react-parser";
import * as React from "react";
import { useEffect, useMemo, useReducer, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useNavigate } from "react-router-dom";
import ShortUniqueId from "short-unique-id";
import { server } from "../App";
import { auth } from "../firebase.js";
import { BlogitModal } from "./blogit";
import { DeleteButton, EditButton, InviteButton, PinButton } from "./buttons";
import { db } from "../firebase.js";
import { Item } from "./extras";
import { InviteModal } from "./invite";
import Note from "./note";
import { tasksReducer } from "./taskreducer";

export default function DashBoard() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [note, setNote] = useState(() => EditorState.createEmpty());
  const [tab, dispatch] = useReducer(tasksReducer, []);
  const [value, setValue] = useState(null);
  const [startNote, setStartNote] = useState(true);
  const [inviteOpen, setInviteOpen] = useState(false);
  const handleInviteClose = () => setInviteOpen(false);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [allowEdit, setAllowEdit] = useState("yes");
  const [ID, setID] = useState();
  const user = auth.currentUser;


  const uid = user?.uid;

  const email = user?.email;

  //to call the database once and get the data

  useEffect(() => {
    if (uid) {
      const fetchNotes = async () => {
        const notesCol = collection(db, "notes");
        const q = query(notesCol, where("uid", "==", uid));
        const notesSnapshot = await getDocs(q);
        const notesList = notesSnapshot.docs.map(doc => doc.data());
        dispatch({ type: "SET_TAB", payload: notesList });
      };
      fetchNotes();
    }
  }, [uid]);


  const { randomUUID } = new ShortUniqueId({
    dictionary: "number",
  });

  //to check if content is empty
  const isContentEmpty = () => {
    const contentState = note.getCurrentContent();
    const blocks = convertToRaw(contentState).blocks;
    return blocks.every((block) => !block.text.trim().length);
  };

  //for the tab change in value
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //for title change
  const onTitleChange = (event) => {
    setTitle(event.target.value);
  };

  //this will get  editor text json stringify it
  const getTextFromEditorState = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const rawContentJSON = JSON.stringify(rawContentState);
    return rawContentJSON;
  };

  //directly convert the editor state to html
  const contentHTML = (editorState) => {
    const HTML = stateToHTML(editorState.getCurrentContent());
    return HTML;
  };

  //this will parse the json convert the singify to html
  const convertToHtml = (data) => {
    if (!data || data === "{}") {
      return "<p>The editor is empty.</p>";
    }
    const rawContentJSON = data;
    const rawContent = JSON.parse(rawContentJSON);
    const contentState = convertFromRaw(rawContent);
    const html = stateToHTML(contentState);
    return html;
  };

  //for edit to convert html back to content state
  const displayReturn = (html) => {
    const rawContentState = JSON.parse(html);
    const contentState = convertFromRaw(rawContentState);
    const newEditorState = EditorState.createWithContent(contentState);
    setNote(newEditorState);
  };

  const handleInviteSubmit = () => {
    if (inviteOpen) {
      axios
        .post("http://localhost:4000/invite", {
          id: ID,
          email: email,
          edit: allowEdit,
        })
        .then((response) => {
          const data = response.data;
          alert(data.invite);
          handleInviteClose();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
          } else {
            console.log("error");
          }

          console.error("There was an error", error);
        });
    }
  };
  //for invite modal
  const handleInvite = (id) => {
    setInviteOpen(true);
    setID(id);
  };

  //get the tab json and convert it to html and display the note
  const tabNote = tab?.map((l) => (
    <>
      <div
        key={l.id}
        hidden={value !== l.id}
        id={`vertical-tabpanel-${l.id}`}
        aria-labelledby={`vertical-tab-${l.id}`}
      >
        <Box sx={{ width: "100%" }}>
          <Stack spacing={2}>
            {value === l.id && (
              <>
                <Item>
                  <span>{HTMLParser(convertToHtml(l.note))}</span>
                  <span style={{ width: "1rem" }}>
                    {l.pin ? <PushPinIcon /> : ""}
                  </span>
                </Item>
              </>
            )}
          </Stack>
        </Box>
        <EditButton handleEdit={() => handleEdit(l.id)} />
        <InviteButton handleInvite={() => handleInvite(l.id)} />
        <DeleteButton handleDelete={() => handleDelete(l.id)} />
        <PinButton handlePin={() => handlePin(l.id)} />

        {l.inviteLink
          ? `https://roko.mutalibb.xyz/invitedraft/${l.inviteLink[0]}`
          : ""}
      </div>
    </>
  ));

  //when save button is cliked
  const handleClick = async (e) => {
    e.preventDefault();
    if (isContentEmpty() || title === "") {
      alert("field cannot be empty");
      return;
    }
    const id = randomUUID();
    const textValue = getTextFromEditorState(note); //get the text and json stringify it
    dispatch({
      type: "added",
      id: id,
      title: title,
      note: textValue,
    });
    setTitle("");
    setNote(() => EditorState.createEmpty());
    await setDoc(
      doc(db, "notes", id),
      { id, title, note: textValue, uid, value: id }
    );
  };

  const handleEdit = (id) => {
    const tabFilter = tab.filter((l) => l.id === id);
    const titleMap = tabFilter[0].title; //tabFilter.map((t) => t.title);
    const noteMap = tabFilter[0].note; //tabFilter.map((t) => t.note);
    setTitle(titleMap);
    displayReturn(noteMap);
    setStartNote(true);
    dispatch({
      type: "delete",
      id: id,
    });
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "notes", id));
    dispatch({
      type: "delete",
      id: id,
    });
  };

  const handlePin = (id) => {
    dispatch({
      type: "pin",
      id: id,
    });
  };

  const sortTab = tab.slice().sort((a, b) => {
    const aHasPin = a.pin === "pin";
    const bHasPin = b.pin === "pin";

    if (aHasPin && !bHasPin) {
      return -1;
    } else if (!aHasPin && bHasPin) {
      return 1;
    } else {
      return 0;
    }
  });

  //for blogit
  const handleBlogIT = (e) => {
    e.preventDefault();
    if (isContentEmpty() || title === "") {
      alert("field cannot be empty");
      return;
    }
    setOpen(true);
  };

  const handleAllowEdit = (event) => {
    setAllowEdit(event.target.value);
  };

  return (
    <>
      <Note
        onTitleChange={onTitleChange}
        title={title}
        note={note}
        setNote={setNote}
        handleClick={handleClick}
        value={value}
        handleChange={handleChange}
        sortTab={sortTab}
        tabNote={tabNote}
        startNote={startNote}
        setStartNote={setStartNote}
        handleBlogIT={handleBlogIT}
      />

      <BlogitModal
        open={open}
        handleClose={handleClose}
        title={title}
        content={getTextFromEditorState(note)}
        contentHTML={contentHTML(note)}
      />

      <InviteModal
        inviteOpen={inviteOpen}
        setAllowEdit={setAllowEdit}
        allowEdit={allowEdit}
        handleAllowEdit={handleAllowEdit}
        handleInviteSubmit={handleInviteSubmit}
        setInviteOpen={() => setInviteOpen(false)}
      />
    </>
  );
}
